import { IOperationRuleAlertUser } from "../../../../stores/data/insightAlerts/insightAlertModel";
import { AlertChannel } from "../../../Alert/types";

export function useChannelValidation() {
    const checkChannelMismatch = (
        selectedUsers: IOperationRuleAlertUser[],
        selectedChannels: AlertChannel[]
    ): string[] => {
        const mismatchedChannels: Set<string> = new Set();

        selectedUsers.forEach((user) => {
            selectedChannels.forEach((channel) => {
                let hasChannel = false;

                switch (channel) {
                    case "whatsapp":
                        hasChannel = user.isWhatsappAllowed ?? false;
                        break;
                    case "email":
                        hasChannel = user.isEmailAllowed ?? false;
                        break;
                    case "push_notification":
                        hasChannel = user.isPushAllowed ?? false;
                        break;
                }

                if (!hasChannel) {
                    mismatchedChannels.add(channel);
                }
            });
        });

        return Array.from(mismatchedChannels);
    };

    return {
        checkChannelMismatch,
    };
}
